import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Img1 from "../Assets/feed1.jpg";
import Img2 from "../Assets/feed2.jpeg";
import Img3 from "../Assets/feed3.jpg";
import Img4 from "../Assets/feed4.jpeg";
import Img5 from "../Assets/feed5.jpg";

const testimonials = [
  {
    name: "Ravi Kumar",
    position: "CEO, TechSolutions",
    message:
      "JCS Global has transformed our workflow with its cutting-edge solutions. The team is highly professional and committed to delivering quality results.",
    image: Img1, // Indian Male Image
  },
  {
    name: "Priya Sharma",
    position: "Marketing Manager, InnovateX",
    message:
      "Amazing experience! The attention to detail and innovation is impressive. Highly recommend JCS Global for smart automation solutions.",
    image: Img2, // Indian Female Image
  },
  {
    name: "Amit Gupta",
    position: "CTO, FutureTech",
    message:
      "JCS Global’s services are top-notch. Their expertise in IoT and automation is truly commendable. Our productivity has skyrocketed!",
    image: Img3, // Indian Male Image
  },
  {
    name: "Neha Desai",
    position: "Product Manager, SmartTech",
    message:
      "The automation solutions provided by JCS Global have significantly streamlined our processes. Excellent customer support as well!",
    image: Img4, // Indian Female Image
  },
  {
    name: "Sandeep Singh",
    position: "Lead Engineer, AutoSync",
    message:
      "Their IoT solutions are truly game-changing. JCS Global has taken our business efficiency to the next level!",
    image: Img5, // Indian Male Image
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section className="bg-gray-100 pb-16 pt-8 px-6 flex flex-col items-center justify-center">
      {/* Section Heading */}
      <h2 className="text-4xl font-bold text-gray-800 text-center mb-10">
        What Our Clients Say About Us
      </h2>

      <div className="relative w-full max-w-4xl flex flex-col md:flex-row items-center justify-center">
        {/* Left Arrow */}
        <button
          className="absolute left-0 bg-white p-3 rounded-full shadow-lg hover:bg-gray-200 transition md:top-1/2 transform -translate-y-1/2"
          onClick={prevTestimonial}
        >
          <ChevronLeft className="text-gray-700" size={30} />
        </button>

        {/* Testimonial Card */}
        <div className="w-full md:w-1/2 text-center bg-white shadow-lg rounded-xl p-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            >
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                className="w-16 h-16 mx-auto rounded-full border-4 border-gray-500"
              />
              <h3 className="text-xl font-semibold text-gray-800 mt-4">
                {testimonials[currentIndex].name}
              </h3>
              <p className="text-sm text-gray-500">
                {testimonials[currentIndex].position}
              </p>
              <p className="text-gray-700 mt-4 italic">
                "{testimonials[currentIndex].message}"
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Right Arrow */}
        <button
          className="absolute right-0 bg-white p-3 rounded-full shadow-lg hover:bg-gray-200 transition md:top-1/2 transform -translate-y-1/2"
          onClick={nextTestimonial}
        >
          <ChevronRight className="text-gray-700" size={30} />
        </button>
      </div>
    </section>
  );
};

export default Testimonials;
